<template>
  <v-row dense class="ma-1 grey lighten-3">
    <v-col cols="2">
      <v-list dense tile expand elevation="2" class="pb-0 ">
        <v-list-item class="mb-2">
          <div class="d-inline">
            <v-avatar size="80" style="border:1px solid grey;">
              <v-img v-if="!!userBillData.avatar" :src="avatar"></v-img>
              <div style="position:absolute;bottom:0;left:0;width:100%;height:25px;opacity: 0.85;" class="pl-2 pr-2 text-center caption teal font-weight-bold">
                <a class="white--text" @click="onUploadAvatar">点击上传</a>
                <input type="file" ref="avatarEditor" class="d-none" @change="onUploadAvatarOk" accept="image/png,image/jpg" />
              </div>
            </v-avatar>

          </div>
          <div class="d-inline ml-4">
            <v-row no-gutters>
              <v-col cols="12" class="text-button">{{username}}</v-col>
              <v-col cols="12">
                <v-row no-gutters align="center">
                  <v-col cols="auto" class="text-button">积分：</v-col>
                  <v-col>
                    <template v-if="!pointVisible">
                      <v-skeleton-loader height="22" type="button"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <a class="orange--text" @click="$router.push('/profile/point')">{{userpoint}}</a>
                      <v-icon x-small color="deep-orange" class="ml-2" @click="reloadPoint">mdi-autorenew</v-icon>
                    </template>
                  </v-col>
                  <v-col cols="12">
                    <router-link class="primary--text text-button text-decoration-none" to="/profile/point/order">充值</router-link>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-list-item>
        <v-list-item to="/profile/summary">
          <v-list-item-icon>
            <v-icon color="deep-purple">mdi-home-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="deep-purple--text font-weight-bold">个人总览</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item  v-for="(item,index) in userNavs" :key="index" :to="item.url">
          <v-list-item-icon>
            <v-icon small :color="item.color" v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon small>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-divider />
        <v-list-item>
          <v-row class="mt-8 mb-8">
            <v-col>
              <v-btn block tile color="red" dark @click="onLogout">
                注 销
                <v-icon right>mdi-logout-variant</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="10">
      <router-view />
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-console */

import { getUserProfile, userLogout, updateAvatar } from '@/plugins/api';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      userNavs: [
        { name: '我的积分', url: '/profile/point', icon: 'mdi-coin', color: 'amber' },
        { name: '我的订单', url: '/profile/order', icon: 'mdi-cash', color: '#BA68C8' },
        { name: '我的消息', url: '/profile/message', icon: 'mdi-message-text-lock', color: '#81C784' },
        { name: '系统公告', url: '/profile/notice', icon: 'mdi-flag-outline', color: '#FFEA00' },
        { name: '留言反馈', url: '/profile/msgboard', icon: 'mdi-message-draw', color: '#4DD0E1' },
        { name: '分析工具', url: '/profile/tool/fav', icon: 'mdi-tools', color: '#29B6F6' },
        { name: '分析任务', url: '/profile/tool/task', icon: 'mdi-link-box-outline', color: '#7986CB' },
        // { name: '我的文件', url: '/profile/file', icon: 'mdi-file', color: '#BA68C8' },
        // { name: '发票信息', url: '/profile/invoice', icon: 'mdi-receipt', color: '#F06292' },
        { name: '修改密码', url: '/profile/auth', icon: 'mdi-shield-key', color: '#FF7043' },
      ],
      listIndex: 0,
      userBillData: {},
      pointVisible: true
    }
  },
  computed: {
    ...mapState({
      avatar: state => state.avatar,
      username: state => state.username,
      userpoint: state => state.userpoint
    })
  },
  created () { this.init() },
  methods: {
    init () {
      getUserProfile().then((res) => {
        this.userBillData = res.data;
        let avatar = `${this.Utility.RES_SERVER}/avatar/${this.userBillData.avatar}?ts=${new Date().getTime()}`;
        this.$store.commit('setAvatar', avatar);
        this.$store.commit('setUsername', this.userBillData.name);
        this.$store.commit('setUserpoint', this.userBillData.point);
      })
    },
    reloadPoint () {
      this.pointVisible = false;
      setTimeout(() => {
        getUserProfile().then((res) => {
          this.userBillData.point = res.data.point;
          this.$store.commit('setUserpoint', this.userBillData.point);
          this.pointVisible = true;
        })
      }, 1500)
    },
    onUploadAvatar () {
      this.$refs.avatarEditor.click();
    },
    onUploadAvatarOk (e) {
      let files = e.target.files;
      if (!files || !files.length) return;
      let param = new FormData();
      param.append('file', files[0]);
      updateAvatar(param).then(() => {
        this.$message.success('上传成功');
        let avatar = `${this.Utility.RES_SERVER}/avatar/${this.userBillData.avatar}?ts=${new Date().getTime()}`;
        this.$store.commit('setAvatar', avatar);
      });
    },
    onLogout () {
      this.$message.confirm('您确定要注销吗？', () => {
        userLogout();
      })
    }
  }
}
</script>